import * as Parse from 'parse';
import { ModelDecorator } from '../decorators';

export enum Types {
    Instagram,
    Facebook,
    Vkontakte,
    AppStore,
    PlayMarket,
    Website,
    Telegram
}

export class Model extends Parse.Object {

    @ModelDecorator.Variable
    public link: string;

    @ModelDecorator.Variable
    public type: Types;

    @ModelDecorator.Variable
    public name: string;

    constructor() { super('ProjectLink'); }

    // tslint:disable-next-line:member-ordering
    public static async getProjectLinksCount() {
        return new Parse.Query(Model).count()
    }

    // tslint:disable-next-line:member-ordering
    public static async searchProjectLink(s: string, limit: number, skip: number, isCount = false) {
        const searchQuery =  new Parse.Query(Model)
        searchQuery.descending('date')
        searchQuery.matches('name', new RegExp(s, 'i'), null);
        if (isCount) {
            return searchQuery.count();
        } else {
            searchQuery.limit(limit);
            searchQuery.skip(skip);
            return searchQuery.find();
        }

    }

    // tslint:disable-next-line:member-ordering
    public static async deleteAllProjectLinks(projectLinks: Model[]) {
        await Model.destroyAll(projectLinks);
    }

    // tslint:disable-next-line:member-ordering
    public static async loadProjectLinks(skip = 0, limit = 25) {
        return await new Parse.Query(Model)
            .descending('date')
            .limit(limit)
            .skip(skip)
            .find()
    }

    // tslint:disable-next-line:member-ordering
    public static async loadProjectLink(projectLinkId: string) {
        const projectLinkQuery = await new Parse.Query(Model);
        const projectLink = await projectLinkQuery.get(projectLinkId);
        return projectLink;
    }

    public async saveFullProjectLink() {
        await this.save();
    }

}

Parse.Object.registerSubclass('ProjectLink', Model);


// WEBPACK FOOTER //
// ./src/models/ProjectLink.ts